import { isSet, convertStrToArrWithSeparator, IsJsonString } from './CommonFunctions';
import { PROFILE_WINDOW_ID, USERS_WINDOW_ID } from '../Global/Constants';

/**
 * Maps filter-window fields for Steps/Ratings condition value pickers.
 * - Loggedin User / Users -> User picker
 * - Loggedin User Profile -> MultiLookup + profiles API
 */
export const resolveFilterWindowFieldInput = (field, defaultElement) => {
    const lookupWindowId = isSet(field.lookup_window_id, '');
    const lookupWindowName = isSet(field.lookup_window_name, '');
    const fieldName = isSet(field.field_name, '');

    if (lookupWindowId === PROFILE_WINDOW_ID
        || lookupWindowName === 'Loggedin User Profile'
        || fieldName === 'Loggedin User Profile') {
        return { element: 'MultiLookup', lookup_window_id: PROFILE_WINDOW_ID };
    }
    if (USERS_WINDOW_ID.indexOf(lookupWindowId) !== -1
        || ['Loggedin User', 'Users'].indexOf(lookupWindowName) !== -1
        || ['Loggedin User', 'Users'].indexOf(fieldName) !== -1) {
        return { element: 'User' };
    }
    return { element: defaultElement };
};

export const toUserSelectedValueJson = (rawSelectedValue, displayName) => {
    if (isSet(rawSelectedValue, '') === '') {
        return rawSelectedValue;
    }
    if (IsJsonString(rawSelectedValue)) {
        try {
            const parsed = JSON.parse(rawSelectedValue);
            if (Array.isArray(parsed)) {
                return rawSelectedValue;
            }
            if (parsed && isSet(parsed.id, '') !== '') {
                return JSON.stringify([{
                    id: parsed.id,
                    first_name: isSet(parsed.dpnm, displayName),
                    last_name: '',
                    value: parsed.id,
                }]);
            }
        } catch (e) {
            return rawSelectedValue;
        }
        return rawSelectedValue;
    }
    const selectedIdArr = convertStrToArrWithSeparator(rawSelectedValue, ',').filter((id) => isSet(id, '') !== '');
    if (selectedIdArr.length === 0) {
        return rawSelectedValue;
    }
    const selectedNameArr = convertStrToArrWithSeparator(displayName, ',');
    return JSON.stringify(selectedIdArr.map((userId, userIndex) => ({
        id: userId,
        first_name: selectedNameArr[userIndex],
        last_name: '',
        value: userId,
    })));
};

export const toMultiLookupSelectedValueJson = (rawSelectedValue, displayName) => {
    if (isSet(rawSelectedValue, '') === '' || IsJsonString(rawSelectedValue)) {
        return rawSelectedValue;
    }
    const selectedIdArr = convertStrToArrWithSeparator(rawSelectedValue, ',').filter((id) => isSet(id, '') !== '');
    if (selectedIdArr.length === 0) {
        return rawSelectedValue;
    }
    const selectedNameArr = convertStrToArrWithSeparator(displayName, ',');
    return JSON.stringify(selectedIdArr.map((lookupId, lookupIndex) => ({
        id: lookupId,
        meta_table_id: lookupId,
        fieldGroups: [{
            type: 'section',
            data: [{
                element: 'TextInput',
                is_default_displayname: true,
                label: { blocks: [{ text: '', entityRanges: [] }] },
                selectedValue: selectedNameArr[lookupIndex],
            }],
        }],
    })));
};
